// src/utils/sessionId.js
export function getSessionId() {
  let id = sessionStorage.getItem('journey_session_id');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('journey_session_id', id);
  }
  return id;
}